import React from 'react'
import IconInstagram from 'svg/icons/icon-instagram.svg'
import IconFacebook from 'svg/icons/icon-facebook.svg'
import IconLinkedIn from 'svg/icons/icon-linkedin.svg'
import IconYoutube from 'svg/icons/icon-youtube.svg'

import './socialLinks.scss'

const icons = [
	{ icon: <IconInstagram />, link: 'https://instagram.com/aurum.br/' },
	{ icon: <IconFacebook />, link: 'https://www.facebook.com/aurumbr' },
	{ icon: <IconLinkedIn />, link: 'https://www.linkedin.com/company/aurumbr' },
	{ icon: <IconYoutube />, link: 'https://www.youtube.com/aurumbr' },
]

const SocialLinks = ({ theme }) => {
	return (
		<ul
			className={`socialLinks ${theme !== undefined && `socialLinks-${theme}`}`}
		>
			{icons.map(({ icon, link }) => {
				return (
					<li className="socialLinks_item" key={link}>
						<a
							href={link}
							target="_blank"
							rel="noopener noreferrer"
							className="socialLinks_link"
						>
							{icon}
						</a>
					</li>
				)
			})}
		</ul>
	)
}

export default SocialLinks
